'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var TableCell = require('@material-ui/core/TableCell');
var Grid = require('@material-ui/core/Grid');
var IconButton = require('@material-ui/core/IconButton');
var styles = require('@material-ui/styles');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
var SortAlphaIcon = require('../icons/SortAlphaIcon.js');
var SortAlphaAscendingIcon = require('../icons/SortAlphaAscendingIcon.js');
var SortAlphaDescendingIcon = require('../icons/SortAlphaDescendingIcon.js');
var SortNumberIcon = require('../icons/SortNumberIcon.js');
var SortNumberAscendingIcon = require('../icons/SortNumberAscendingIcon.js');
var SortNumberDescendingIcon = require('../icons/SortNumberDescendingIcon.js');
var SortGenericIcon = require('../icons/SortGenericIcon.js');
var SortGenericAscendingIcon = require('../icons/SortGenericAscendingIcon.js');
var SortGenericDescendingIcon = require('../icons/SortGenericDescendingIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TableCell__default = /*#__PURE__*/_interopDefaultLegacy(TableCell);
var Grid__default = /*#__PURE__*/_interopDefaultLegacy(Grid);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);

var _excluded = ["onClick", "label", "isSelected", "type", "direction"];
var useStyles = styles.makeStyles(theme => ({
  head: {
    cursor: 'pointer',
    padding: "2px 4px 0 4px",
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.grey[200]
    }
  },
  isSelected: {
    color: theme.palette.primary.main
  },
  wrapper: {
    padding: 2
  },
  iconButton: {
    height: 22,
    width: 22
  },
  icon: {
    fontSize: 18
  }
}));
var ALPHA = 'alpha';
var NUMBER = 'number';
var GENERIC = 'generic';
var ASC = 'asc';
var DESC = 'desc';
/** Get the icon component given sort type and direction. */

function getSortIcon(isSelected, type, direction) {
  if (type === ALPHA) {
    return !isSelected ? SortAlphaIcon.SortAlphaIcon : direction === ASC ? SortAlphaAscendingIcon.SortAlphaAscendingIcon : SortAlphaDescendingIcon.SortAlphaDescending;
  }

  if (type === DESC) {
    return !isSelected ? SortNumberIcon.SortNumberIcon : direction === ASC ? SortNumberAscendingIcon.SortNumberAscending : SortNumberDescendingIcon.SortNumberDescending;
  }

  return !isSelected ? SortGenericIcon.SortGenericIcon : direction === ASC ? SortGenericAscendingIcon.SortNumberDescending : SortGenericDescendingIcon.SortNumberDescending;
}

var SortableTableHeadCell = _ref => {
  var {
    onClick,
    label,
    isSelected = false,
    type = GENERIC,
    direction = ASC
  } = _ref,
      tableCellProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  var IconComponent = getSortIcon(isSelected, type, direction);
  return /*#__PURE__*/React__default['default'].createElement(TableCell__default['default'], _rollupPluginBabelHelpers['extends']({}, tableCellProps, {
    className: clsx_m(classes.head, isSelected && classes.isSelected),
    onClick: onClick
  }), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    container: true,
    wrap: "nowrap",
    className: classes.wrapper
  }, /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true
  }, label), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true
  }, /*#__PURE__*/React__default['default'].createElement(IconButton__default['default'], {
    className: classes.icon,
    color: isSelected ? 'primary' : 'default',
    onClick: onClick
  }, /*#__PURE__*/React__default['default'].createElement(IconComponent, {
    className: classes.icon
  })))));
};
SortableTableHeadCell.propTypes = {
  type: index.oneOf([ALPHA, NUMBER, GENERIC]),
  direction: index.oneOf([ASC, DESC]),
  label: index.string.isRequired,
  isSelected: index.bool,
  onClick: index.func
};

exports.SortableTableHeadCell = SortableTableHeadCell;
